export default __webpack_public_path__ + "static/media/cloudy.58e03de7.gif";